import { ViewModelProperty } from '@ldw/roesberg';

export class DocumentCopyDataGroup {
  groupName = ""
  fields : ViewModelProperty[] = [];
}
